module.exports = __webpack_public_path__ + "img/icon-foreman-cover.012b44ae.png";